import { render, staticRenderFns } from "./nshop-list-viewer.vue?vue&type=template&id=b517ab12&scoped=true&"
import script from "./nshop-list-viewer.vue?vue&type=script&lang=js&"
export * from "./nshop-list-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b517ab12",
  null
  
)

export default component.exports